import Icon from "components/Elements/Icon/Icon";
import { ISideBarPromoParams } from "./models";
import { useContent } from "contexts/contentContext/contentContext";
import { ButtonAccessability } from "components/Elements/Button/Button";

import styles from "./sibeBarPromo.module.scss";

const SideBarJPayPromo = ({
  swapFormFunction,
  setClosed,
  collapsed,
}: ISideBarPromoParams) => {
  const { getTextByKey, getDirection } = useContent();

  const handleClose = (e: MouseEvent) => {
    e.stopPropagation();
    setClosed(true);
  };

  const handleClick = () => {
    swapFormFunction && swapFormFunction("pay-light");
  };

  return (
    <button
      className={
        styles.container +
        (getDirection() === "rtl" ? ` ${styles.rtl}` : "") +
        (collapsed ? ` ${styles.collapsed}` : "")
      }
      type="button"
      onClick={handleClick}
    >
      {/* @ts-ignore */}
      <ButtonAccessability onClick={handleClose} className={styles.closeButton}>
        <Icon name="x" gray />
      </ButtonAccessability>
      <div className={styles.iconContainer}>
        <Icon name="jpay" blue />
      </div>
      <div className={styles.textContainer}>
        {getTextByKey("inbox-payment-options-title")}
        <span>{getTextByKey("charge-my-files-text")}</span>
      </div>
      <div className="flex-spacer" />
      <Icon name="arrow-right" iconClass={styles.chargeIcon} gray />
    </button>
  );
};

export default SideBarJPayPromo;
